// extracted by mini-css-extract-plugin
export default {"progressWrapper":"styles_progressWrapper__jb42C"};